{
  "eyebrow": "Създайте акаунт",
  "title": "Няколко детайла за вашата компания.",
  "sub": "Вие ще сте главният администратор. Можете да поканите още администратори след настройката.",
  "company": "Компания",
  "companyName": "Име на компанията",
  "companyVat": "Номер по ДДС",
  "companyVatBssHint": "Изисква се за подаване към белгийската социална осигуровка (DIMONA).",
  "companyCountry": "Държава",
  "admin": "Главен администратор",
  "adminFirst": "Име",
  "adminLast": "Фамилия",
  "adminEmail": "Служебен имейл",
  "adminPhone": "Телефон",
  "adminPw": "Парола",
  "adminPwHint": "Поне 10 символа, една цифра.",
  "adminPwShow": "Покажи паролата",
  "adminPwHide": "Скрий паролата",
  "terms": {
    "pre": "Съгласен съм с",
    "t": "Условията за ползване",
    "and": "и",
    "p": "Политиката за поверителност"
  },
  "cta": "Създай акаунт и продължи",
  "errors": {
    "required": "Задължително",
    "tooShort": "Твърде късо",
    "invalidEmail": "Въведете валиден имейл",
    "invalidVat": "Въведете валиден ДДС номер",
    "invalidBelgianVat": "Въведете валиден белгийски ДДС номер (напр. BE0123456789).",
    "invalidPhone": "Въведете валиден телефонен номер",
    "passwordWeak": "Поне 10 символа и една цифра",
    "termsRequired": "Трябва да приемете условията",
    "emailExists": "Този имейл вече се използва",
    "vatRequiredForBss": "ДДС номерът е задължителен за белгийската социална осигуровка",
    "network": "Грешка в мрежата или сървъра. Опитайте отново."
  },
  "verify": {
    "awaitingTitle": "Проверете пощата си",
    "awaitingSub": "Изпратихме линк за потвърждение на {{email}}. Кликнете върху него, за да активирате акаунта си и да започнете безплатния пробен период.",
    "awaitingSubNoEmail": "Изпратихме ви линк за потвърждение. Кликнете върху него, за да активирате акаунта си и да започнете безплатния пробен период.",
    "resend": "Изпрати отново",
    "resendCooldown": "Изпрати отново след {{seconds}}с",
    "verifyingTitle": "Проверка…",
    "successTitle": "Вашият безплатен 30-дневен пробен период започна!",
    "successSub": "Без кредитна карта. Влезте в таблото си, за да започнете да използвате Done-it.",
    "errorTitle": "Не успяхме да проверим този линк",
    "errorSub": "Линкът може да е изтекъл. Започнете отначало от данните за акаунта си.",
    "errorCta": "Назад към акаунта",
    "interstitial": "Потвърждение на имейл",
    "subscribedTitle": "Профилът ви е готов",
    "subscribedSub": "Плащането вече е завършено. Влезте в таблото си, за да започнете с Done-it.",
    "subscribedCta": "Вход в таблото",
    "successCta": "Отваряне на таблото",
    "successNote": "По време на пробния период ще получите няколко полезни имейла, а към края — линк за абониране.",
    "awaitingSubFree": "Изпратихме връзка за потвърждение на {{email}}. Кликнете върху нея, за да активирате безплатния си акаунт — Time Zero е безплатен завинаги, без кредитна карта.",
    "awaitingSubFreeNoEmail": "Изпратихме ви връзка за потвърждение. Кликнете върху нея, за да активирате безплатния си акаунт — Time Zero е безплатен завинаги, без кредитна карта.",
    "successTitleFree": "Вашият безплатен акаунт е готов!",
    "successNoteFree": "Time Zero е безплатен завинаги в рамките на ограниченията си. Надстройте по всяко време за неограничено използване."
  }
}
